import React, { useState } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { Container, Form, Input } from "reactstrap";
import classes from "./style.module.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  gstinPattern,
  mailPattern,
  nonstrongPwd,
} from "../../variables/constants";
import { phoneVerify, signupIntegration } from "../../apiServices/authServices";
import { emailVerify } from "../../apiServices/authServices";

import toast from "react-hot-toast";

function RegisterForm() {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    confirmPassword: "",
    user_type: "",
    gst_no: "",
    company_name: "",
  });
  const [isValid, setIsValid] = useState({
    isEmailValid: false,
    isPasswordValid: false,
    isConfirmPasswordValid: false,
    isGstValid: true,
  });
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const validateGSTField = (value) => {
    const val = value.trim();

    return gstinPattern.test(val.toUpperCase()) || val.length === 0;
  };

  const handleChange = (e) => {
    if (e.target.name === "email") {
      if (mailPattern.test(e.target.value)) {
        setIsValid({ ...isValid, isEmailValid: true });
      } else {
        setIsValid({ ...isValid, isEmailValid: false });
      }
    } else if (e.target.name === "password") {
      if (nonstrongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, isPasswordValid: true });
      } else {
        setIsValid({ ...isValid, isPasswordValid: false });
      }
    } else if (e.target.name === "confirmPassword") {
      if (
        data.password === e.target.value &&
        e.target.value === data.password
      ) {
        setIsValid({ ...isValid, isConfirmPasswordValid: true });
      } else {
        setIsValid({ ...isValid, isConfirmPasswordValid: false });
      }
    } else if (e.target.name === "gst_no") {
      const isValidGST = validateGSTField(e.target.value);
      setIsValid({ ...isValid, isGstValid: isValidGST });
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await emailVerify({
        email: data.email,
        phone: data.phone, // ⭐ IMPORTANT
      });

      if (res.responseCode === 200) {
        navigate("/verification", {
          state: { data, session_id: res.responseData.session_id },
        });
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseMessage || error.message);
    }
  };
  return (
    <Container className={`${classes.loginForm} overflow-hidden`}>
      <h2
        className="text-4xl font-bold pt-10 w-[340px] sm:w-full"
        style={{ color: "#1E2219" }}
      >
        Create Account.
      </h2>
      <p className="mb-6 mt-1 text-gray-500 w-[340px] sm:w-full">
        Note: Verified company name receive Vendor Priority
      </p>
      <Form
        className="flex flex-col !w-[340px] sm:!w-[380px] md:!w-[500px]"
        onSubmit={handleSubmit}
      >
        <Container className="px-4 mb-4">
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            // defaultValue=""
            name="radio-buttons-group"
            className="flex !flex-row gap-7"
          >
            <FormControlLabel
              value="1"
              // disabled={props.editData.orderStatus !== 3 ? true : false}
              control={
                <Radio
                  sx={{
                    color: "#800000",
                    "&.Mui-checked": {
                      color: "#800000",
                    },
                  }}
                  onChange={(e) => {
                    setData({ ...data, user_type: e.target.value });
                  }}
                />
              }
              label="Individual"
              sx={{
                marginRight: "0",
                "& .MuiTypography-root": {
                  fontFamily: "Poppins",
                },
              }}
            />
            <FormControlLabel
              value="2"
              // disabled={props.editData.orderStatus !== 3 ? true : false}
              control={
                <Radio
                  sx={{
                    color: "#800000",
                    "&.Mui-checked": {
                      color: "#800000",
                    },
                  }}
                  onChange={(e) => {
                    setData({ ...data, user_type: e.target.value });
                  }}
                />
              }
              label="Corporate"
              sx={{
                marginRight: "0",
                "& .MuiTypography-root": {
                  fontFamily: "Poppins",
                },
              }}
            />
          </RadioGroup>
        </Container>

        <Container className="mb-6">
          <Input
            type="text"
            name="name"
            placeholder="Name *"
            onChange={handleChange}
            value={data.name}
            className="!w-full"
            required
          />
        </Container>
        <Container className="mb-6">
          <Input
            type="email"
            name="email"
            placeholder="Email *"
            onChange={handleChange}
            value={data.email}
            className="!w-full"
            required
          />
          {!isValid.isEmailValid && data.email && (
            <p className={`${classes.errorMsg} mt-2 ml-4 text-rose-600`}>
              Please enter valid email address
            </p>
          )}
        </Container>
        <Container className="mb-6">
          <PhoneInput
            country={"in"}
            onChange={(e) => setData({ ...data, phone: "+" + e })}
            inputStyle={{
              paddingTop: "1.8rem",
              paddingBottom: "1.8rem",
              height: "calc(1.5em + 1.25 rem+ 2px )",
              width: "100%",
              fontWeight: 400,
              lineHeight: 1.5,
              color: "#000",
              backgroundClip: "padding-box",
              borderRadius: "1rem",
              border: "1px solid #800000",
              fontFamily: "Poppins",
              fontSize: "17px",
            }}
            inputClass={classes.phoneInput}
            dropdownStyle={{ fontFamily: "Poppins" }}
            buttonStyle={{
              background: "#fff",
              borderTopLeftRadius: "1rem",
              borderBottomLeftRadius: "1rem",
              borderLeft: "none",
              borderTop: "none",
              borderBottom: "none",
              display: "block",
              border: "1px solid #800000",
            }}
            searchStyle={{
              width: "85%",
            }}
            enableSearch
            isValid={(value, country) => {
              if (value === country.dialCode) {
                return true;
              }
              return isValidPhoneNumber("+" + value);
            }}
            defaultErrorMessage="Please enter valid number"
          />
        </Container>

        {data.user_type == 2 && (
          <Container className="mb-6">
            <Input
              type="text"
              name="company_name"
              placeholder="Company name"
              className="!w-full"
              onChange={handleChange}
              value={data.company_name}
            />
          </Container>
        )}

        {(data.user_type == 1 || data.user_type == 2) && (
          <Container className="mb-6">
            <Input
              type="text"
              name="gst_no"
              placeholder="GST no. (e.g., 07AAAAA0000A1Z5)"
              className="!w-full"
              onChange={handleChange}
              value={data.gst_no}
            />
          </Container>
        )}

        <Container className="mb-6">
          <Container className="flex items-center">
            <Input
              type={isPasswordVisible ? "text" : "password"}
              name="password"
              placeholder="Password *"
              onChange={handleChange}
              value={data.password}
              className="!w-full"
              required
            />
            {isPasswordVisible ? (
              <LuEye className="-ml-7" onClick={togglePasswordVisibility} />
            ) : (
              <LuEyeOff className="-ml-7" onClick={togglePasswordVisibility} />
            )}
          </Container>
          {!isValid.isPasswordValid && data.password && (
            <p className={`${classes.errorMsg} mt-2 ml-4 text-rose-600`}>
              Password must have atleast 1 uppercase,
              <br /> lowercase, number, special characters
              <br /> and minimum 8 characters.
            </p>
          )}
        </Container>
        <Container className="mb-2">
          <Container className="flex items-center">
            <Input
              type={isConfirmPasswordVisible ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password *"
              onChange={handleChange}
              value={data.confirmPassword}
              className="!w-full"
              required
            />
            {isConfirmPasswordVisible ? (
              <LuEye
                className="-ml-7"
                onClick={toggleConfirmPasswordVisibility}
              />
            ) : (
              <LuEyeOff
                className="-ml-7"
                onClick={toggleConfirmPasswordVisibility}
              />
            )}
          </Container>
          {!isValid.isConfirmPasswordValid && data.confirmPassword && (
            <p className={`${classes.errorMsg} mt-2 ml-4 text-rose-600`}>
              Passwords must be same.
            </p>
          )}
        </Container>
        <Container className="flex justify-start items-center mb-5">
          <Checkbox
            defaultChecked={false}
            sx={{
              color: "#800000",
              pointerEvents: "auto",
              "&.Mui-checked": {
                color: "#800000",
              },
            }}
            onChange={(e) => setIsCheckboxClicked(e.target.checked)}
            required
          />
          <p className="w-[255px] md:w-full">
            I accept all{" "}
            <span className="text-[#800000] font-semibold cursor-pointer">
              Terms of Services
            </span>{" "}
            &{" "}
            <span className="text-[#800000] font-semibold cursor-pointer">
              Privacy policy
            </span>
            *
          </p>
        </Container>
        <input
          type="submit"
          value="Register"
          className="active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out !w-full"
          disabled={
            !isValid.isEmailValid ||
            !isValid.isPasswordValid ||
            !isValidPhoneNumber(data.phone) ||
            !isValid.isConfirmPasswordValid ||
            !data.user_type ||
            !isCheckboxClicked
              ? true
              : false
          }
        />
      </Form>

      <Container className="flex justify-center my-4">
        <p>
          Already a user?{" "}
          <span className="font-semibold cursor-pointer">
            <Link to="/login">Login</Link>
          </span>
        </p>
      </Container>
    </Container>
  );
}

export default RegisterForm;
